import { NETWORK_LOG } from "../../../constants/envConstant";
import { CRITICAL_ACTION_TIMEOUT } from "../../../constants/values";
import { apiEndPoint, apiEndPointCrpt, apiEndPointMyRadon } from "../../../env";
import { AuthUtil } from "../../../views/auth/AuthUtil";

const MyRadonInterface = {
  getMyRadonAnalysis: async function (email, reportId) {
    let requestUrl = apiEndPointMyRadon + "/premium/insight/reports";
    const controller = new AbortController();
    let token = "";
    try {
      token = await AuthUtil.getAuthToken();
    } catch (e) {
      console.warn("[MyRadonInterface] Token retrieval error:", e);
    }
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: token } : {}),
      },
      signal: controller.signal,
      credentials: "include",
      cache: "no-cache",
    };
    const timeoutId = setTimeout(
      () => controller.abort(),
      CRITICAL_ACTION_TIMEOUT
    );

    let queryParams = [];
    if (email) queryParams.push(`email=${encodeURIComponent(email)}`);
    if (reportId) queryParams.push(`reportId=${encodeURIComponent(reportId)}`);
    let url = queryParams.length > 0 ? `${requestUrl}?${queryParams.join("&")}` : requestUrl;

    let res = await fetch(url, requestOptions)
      .then((res) => {
        return res.text().then((text) => {
          const data = text && JSON.parse(text);
          return data;
        });
      })
      .catch((err) => {
        if (err.name === "AbortError") {
          return "fetch() request was aborted, hit CTRL-R to try again.";
        }
        console.log(err);
      });
    clearTimeout(timeoutId);
    return res;
  },
  getMyReportList: async function (email) {
    let requestUrl = apiEndPointCrpt + "/reports";
    const controller = new AbortController();
    let token = "";
    try {
      token = await AuthUtil.getAuthToken();
    } catch (e) {
      console.warn("[MyRadonInterface] Token retrieval error:", e);
    }
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: token } : {}),
      },
      signal: controller.signal,
      credentials: "include",
      cache: "no-cache",
    };

    const timeoutId = setTimeout(
      () => controller.abort(),
      CRITICAL_ACTION_TIMEOUT
    );
    let url = email ? `${requestUrl}?email=${encodeURIComponent(email)}` : requestUrl;

    let res = await fetch(url, requestOptions)
      .then((res) => {
        return res.text().then((text) => {
          const data = text && JSON.parse(text);
          return data;
        });
      })
      .catch((err) => {
        if (err.name === "AbortError") {
          return "fetch() request was aborted, hit CTRL-R to try again.";
        }
        console.log(err);
      });
    clearTimeout(timeoutId);
    return res;
  },

  getMyRadonList: async function (email) {
    let requestUrl = apiEndPoint + "/premium/insight/reports";
    const controller = new AbortController();
    let token = await AuthUtil.getAuthToken();
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json", Authorization: token },
      signal: controller.signal,
      credentials: "include",
      cache: "no-cache",
    };

    const timeoutId = setTimeout(
      () => controller.abort(),
      CRITICAL_ACTION_TIMEOUT
    );
    let res = await fetch(requestUrl + "?email=" + email, requestOptions)
      .then((res) => {
        return res.text().then((text) => {
          const data = text && JSON.parse(text);
          return data;
        });
      })
      .catch((err) => {
        if (err.name === "AbortError") {
          return "fetch() request was aborted, hit CTRL-R to try again.";
        }
        console.log(err);
      });
    return res;
  },

  getMyRadonDetails: async function (email, reportId) {
    let requestUrl = apiEndPoint + "/premium/insight/reports";
    const controller = new AbortController();
    let token = await AuthUtil.getAuthToken();
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json", Authorization: token },
      signal: controller.signal,
      credentials: "include",
    };
    const timeoutId = setTimeout(
      () => controller.abort(),
      CRITICAL_ACTION_TIMEOUT
    );

    console.log('param = ' + requestUrl + "?email=" + email + "&reportId=" + reportId + ':::' + JSON.stringify(requestOptions));

    let res = await fetch(
      requestUrl + "?email=" + email + "&reportId=" + reportId,
      requestOptions
    )
      .then((res) => {
        // console.log('res = ' + JSON.stringify(res));
        return res.text().then((text) => {
          const data = text && JSON.parse(text);
          return data;
        });
      })
      .catch((err) => {
        if (err.name === "AbortError") {
          return "fetch() request was aborted, hit CTRL-R to try again.";
        }
        console.log(err);
      });
    return res;
  },

  cancelAnalysis: async (serialNumber, reportId) => {
    let requestUrl = apiEndPoint + "/premium/insight/request";
    const controller = new AbortController();
    let token = await AuthUtil.getAuthToken();
    const requestOptions = {
      method: "DELETE",
      headers: { "Content-Type": "application/json", Authorization: token },
      signal: controller.signal,
      credentials: "include",
      cache: "no-cache",
    };
    const timeoutId = setTimeout(
      () => controller.abort(),
      CRITICAL_ACTION_TIMEOUT
    );
    let res = await fetch(
      requestUrl + "?serialNumber=" + serialNumber + "&reportId=" + reportId,
      requestOptions
    )
      .then((res) => {
        return res.text().then((text) => {
          const data = text && JSON.parse(text);
          return data;
        });
      })
      .catch((err) => {
        if (err.name === "AbortError") {
          return "fetch() request was aborted, hit CTRL-R to try again.";
        }
        console.log(err);
      });

    return res;
  },

  deleteReports: async function (items) {
    let requestUrl = apiEndPointCrpt + "/reports";
    const controller = new AbortController();
    let token = "";
    try {
      token = await AuthUtil.getAuthToken();
    } catch (e) {
      console.warn("[MyRadonInterface] Token retrieval error:", e);
    }
    const itemsArray = Array.isArray(items) ? items : [items];
    const requestOptions = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: token } : {}),
      },
      body: JSON.stringify({ items: itemsArray }),
      signal: controller.signal,
      credentials: "include",
      cache: "no-cache",
    };
    const timeoutId = setTimeout(
      () => controller.abort(),
      CRITICAL_ACTION_TIMEOUT
    );

    let res = await fetch(requestUrl, requestOptions)
      .then((res) => {
        return res.text().then((text) => {
          const data = text && JSON.parse(text);
          return data;
        });
      })
      .catch((err) => {
        if (err.name === "AbortError") {
          return "fetch() request was aborted, hit CTRL-R to try again.";
        }
        console.log(err);
      });
    clearTimeout(timeoutId);
    return res;
  },

  getConf: async function () {
    let requestUrl = "https://api.hub-dev.ecosense.io/api/v1/conf";
    const controller = new AbortController();
    let token = "";
    try {
      token = await AuthUtil.getAuthToken();
    } catch (e) {
      console.warn("[MyRadonInterface] Token retrieval error:", e);
    }
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: token } : {}),
      },
      signal: controller.signal,
      credentials: "include",
      cache: "no-cache",
    };

    const timeoutId = setTimeout(
      () => controller.abort(),
      CRITICAL_ACTION_TIMEOUT
    );

    let res = await fetch(requestUrl, requestOptions)
      .then((res) => {
        return res.text().then((text) => {
          const data = text && JSON.parse(text);
          return data;
        });
      })
      .catch((err) => {
        if (err.name === "AbortError") {
          return "fetch() request was aborted, hit CTRL-R to try again.";
        }
        console.log(err);
      });
    clearTimeout(timeoutId);
    return res;
  },

  log: function (msg, flag) {
    if (NETWORK_LOG || flag) console.log(`[MyRadonInterface] ${msg}`);
  },
};

export default MyRadonInterface;
